export const red = {
  red100: '#FCD8CB',
  red200: '#FAAA99',
  red300: '#F27165',
  red400: '#E53F40',
  red500: '#D5071C',
  red600: '#B70527',
  red700: '#99032E',
  red800: '#7B022F',
  red900: '#660130',
  surfaceRed: '#CD0E0E',
};
